module.exports = __webpack_public_path__ + "static/media/default_icon.65601d28.svg";